import { ChangeDetectionStrategy, Component, computed, input, } from '@angular/core';
import { ByPassPipe } from '../../pipes/by-pass.pipe';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-inner-html',
  template: `
    <div [classList]="unresetClasses()" [innerHtml]="html() | byPass"></div>
  `,
  imports: [
    ByPassPipe
  ]
})
/**
 * Display an error
 */
export class InnerHtmlComponent {
  html = input.required<string>()
  classes = input('')
  unresetClasses = computed(() => this.classes() + ' unreset')
}
